import React, { useEffect } from "react";
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';
import Slider from "react-slick";
import QrCodeIcon from '@mui/icons-material/QrCode';
import AndroidIcon from '@mui/icons-material/Android';
import Dialog from '@mui/material/Dialog';

import logo from '../../static/logo/logo_1.png';
import bh_xcx_2 from '../../static/image/bh_xcx_2.jpg'
import kuai_engine from '../../static/image/kuai_engine.jpg'

import accountant_icon from '../../static/icon/accountant_icon.png'
import tax_icon from '../../static/icon/tax_icon.png'


const useStyles = makeStyles((theme) => ({
    root: {
        padding: "0px  !important",
        margin: 0,
        maxWidth: '100%',
        overflowX: 'hidden'
    }
}));

function SimpleDialog(props) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <div style={{textAlign:'center',paddingTop:'10px',fontSize:'20px',fontWeight:'bold'}}>博槐税引擎</div>
            <img src={selectedValue} style={{ width: 300 }} alt='' />
        </Dialog>
    );
}

function Initial() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState('');

    const Shuilider=()=> {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            accessibility: false,
            arrows: false,
            autoplay: true,
            pauseOnDotsHover: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <Slider {...settings}>
                <div id='tax_planning'>
                    <p style={{fontSize:28,textAlign:'center',margin:'30px 0'}} onClick={() => handleClickOpen(1)}>博槐税引擎小程序<QrCodeIcon style={{ marginLeft: 10, cursor: 'pointer' }} /></p>
                    <div>
                        <div style={{ padding: 20 ,paddingBottom:70}}> 
                            <div style={{ width: '70%', textAlign:'center',margin:'0 auto'}}>
                                <LazyLoad height={600} once={true}>
                                    <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/phone_gif.gif'} style={{ width: 300 ,maxWidth:'100%'}} alt='' />
                                </LazyLoad>
                            </div>
                            <div style={{textAlign:'center',paddingTop:40}}>
                                <div style={{ fontWeight: 'bold', fontSize: 21 }}>税务知识库搜索</div>
                                <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>毫秒级搜索税务相关知识，了解税务筹划方案以及以往案例，身旁的便携税务筹划专家</div>
                                <div style={{ fontWeight: 'bold', fontSize: 21 }}>自动税务筹划调查问卷</div>
                                <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>在小程序内填写调查问卷后，根据您的回答自动生成专属于您的一系列税务筹划方案</div>
                                <div style={{ fontWeight: 'bold', fontSize: 21 }}>价廉物美的服务</div>
                                <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>以往动辄几万元的税务筹划方案只用十几块就可以无限次使用，还在等什么，快来试试吧！</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id='tax_planning'>
                    <p style={{fontSize:28,textAlign:'center',margin:'30px 0'}} onClick={() => handleClickOpen(1)}>博槐税引擎小程序<QrCodeIcon style={{ marginLeft: 10, cursor: 'pointer' }} /></p>
                    <div>
                        <div style={{ padding: 20 ,paddingBottom:70}}> 
                            <div style={{ width: '70%', textAlign:'center',margin:'0 auto'}}>
                                <LazyLoad height={600} once={true}>
                                    <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/shui_tax_gif.gif'} style={{ width: 300 ,maxWidth:'100%'}} alt='' />
                                </LazyLoad>
                            </div>
                            <div style={{textAlign:'center',paddingTop:40}}>
                                <div style={{ fontWeight: 'bold', fontSize: 21 }}>税务知识库搜索</div>
                                <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>毫秒级搜索税务相关知识，了解税务筹划方案以及以往案例，身旁的便携税务筹划专家</div>
                                <div style={{ fontWeight: 'bold', fontSize: 21 }}>自动税务筹划调查问卷</div>
                                <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>在小程序内填写调查问卷后，根据您的回答自动生成专属于您的一系列税务筹划方案</div>
                                <div style={{ fontWeight: 'bold', fontSize: 21 }}>价廉物美的服务</div>
                                <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>以往动辄几万元的税务筹划方案只用十几块就可以无限次使用，还在等什么，快来试试吧！</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>
        );
    }
    
    const handleClickOpen = (e) => {
        if (e === 1) {
            setSelectedValue(bh_xcx_2);
        } else {
            setSelectedValue('https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/tax_agent_app/download_tax_agent.png');
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

    };
    const to_tax_planning = () => {
        console.log(12)
        const anchorElement = document.getElementById('tax_planning'); //找到滚动到的元素
        if (anchorElement) {
            anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // 让页面滚动到元素所在位置
        }
    }
    const to_tax_accountant = () => {
        const anchorElement = document.getElementById('tax_accountant'); //找到滚动到的元素
        if (anchorElement) {
            anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // 让页面滚动到元素所在位置
        }
    }

    return (
        <Container className={classes.root}>
            <div>
                <div style={{ backgroundColor: '#3D1198', color: '#fff', width: '100%', height: 450,position:'relative',display:'flex',justifyContent:'space-between' }}>
                    <div style={{maxWidth:'100%'}}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', padding: '20px', fontSize: 20 }}>
                                <div>
                                    <img src={logo} style={{ width: '26px', height: '26px', background: '#fff', borderRadius: '50%' }} alt="" />
                                </div>
                                <div style={{ paddingLeft: 8 }}>博槐互联网科技</div>
                            </div>
                        </div>
                        <div style={{ padding: 30 }}>
                            <div style={{ fontSize: 36, paddingBottom: 40 }}>博槐互联网科技</div>
                            <div style={{fontSize:16,width:'100%'}}>博槐（北京）互联网科技有限责任公司是一家以科技为驱动，以用户为导向的创新型智能企服公司。公司致力于用最先进的技术为企业和企业内专业从业人员提供智能化互联网解决方案，以提高整体效率并节约成本。</div>
                        </div>
                        <div style={{ display: 'flex',justifyContent:'center',padding: '26px 30px 0 30px' }}>
                            {/* <Link onClick={() => window.location.href = 'http://101.35.94.104:3070'} > */}
                                <div onClick={to_tax_planning} style={{ borderRadius: 25, padding: '10px',width:'100px', background: '#fff', color: '#000000',maxWidth:'200px', height: 33, textAlign: 'center', lineHeight: '40px',fontSize:14,display:'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'center'}}>
                                        <img src={tax_icon} style={{width:27}} />
                                    <div style={{marginLeft: 10}}> 税引擎</div>
                                </div>
                            {/* </Link> */}
                            {/* <Link onClick={() => window.location.href = 'http://huainor.ac.cn'} style={{marginLeft:'10%'}}> */}
                                <div onClick={to_tax_accountant} style={{marginLeft:'10%', borderRadius: 25, padding: '10px',width:'100px', background: '#fff', color: '#000000',maxWidth:'200px', height: 33, textAlign: 'center', lineHeight: '40px',fontSize:14,display:'flex' ,flexDirection: "row", alignItems: 'center', justifyContent: 'center'}}>
                                    <img src={accountant_icon} style={{width:25}} />
                                    <div style={{marginLeft: 10}}>税务师</div>
                                </div>
                            {/* </Link> */}
                        </div>
                    </div>
                </div>
                <div style={{ padding: '20px 30px 30px'}}>
                    <div style={{display:'flex'}}>
                        <div style={{width:'45%',textAlign:'center'}}>
                            <p style={{ fontSize: 12, }}>税引擎小程序</p>
                            <div>
                                <img src={bh_xcx_2} style={{ width: 100 }} alt='' />
                            </div>
                        </div>
                        <div style={{width:'45%',textAlign:'center'}}>
                            <p style={{ fontSize: 12 }}>税务师引擎</p>
                            <div >
                                <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/tax_agent_app/download_tax_agent.png'} style={{ width: 100 }} alt='' />
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{width:'45%'}}>
                            <div style={{ width: 100, background: '#000', height: 1, margin:'0 auto',marginTop: 11 }}></div>
                        </div>
                        
                        <div>or</div>
                        <div style={{width:'45%'}}>
                            <div style={{ width: 100, background: '#000', height: 1, margin:'0 auto',marginTop: 11 }}></div>
                        </div>
                    </div>
                </div>
                
                {/* <p style={{fontSize:28,textAlign:'center',margin:'30px 0'}}>博槐税引擎小程序</p> */}
                <div>
                    <Shuilider/>
                    {/* <div style={{ padding: 20 ,paddingBottom:70}}> 
                        <div style={{ width: '70%', textAlign:'center',margin:'0 auto'}}>
                            <LazyLoad height={600} once={true}>
                                <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/phone_gif.gif'} style={{ width: 300 ,maxWidth:'100%'}} alt='' />
                            </LazyLoad>
                        </div>
                        <div style={{textAlign:'center',paddingTop:40}}>
                            <div style={{ fontWeight: 'bold', fontSize: 21 }}>税务知识库搜索</div>
                            <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>毫秒级搜索税务相关知识，了解税务筹划方案以及以往案例，身旁的便携税务筹划专家</div>
                            <div style={{ fontWeight: 'bold', fontSize: 21 }}>自动税务筹划调查问卷</div>
                            <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>在小程序内填写调查问卷后，根据您的回答自动生成专属于您的一系列税务筹划方案</div>
                            <div style={{ fontWeight: 'bold', fontSize: 21 }}>价廉物美的服务</div>
                            <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>以往动辄几万元的税务筹划方案只用十几块就可以无限次使用，还在等什么，快来试试吧！</div>
                        </div>
                    </div> */}
                    <div style={{padding: 20 ,backgroundColor:'rgb(61, 17, 152)',margin:'30px 0',paddingBottom:90,marginBottom:0}}>
                        <div style={{color:'#fff',textAlign:'center',fontSize:28,margin:'60px 0'}}>博槐股税通搜索引擎</div>
                        <div style={{ width: '100%'  }}>
                            <LazyLoad height={450} once={true}>
                                <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/video_gif.gif'} style={{ width: 750 ,maxWidth:'100%'}} alt='' />
                            </LazyLoad>
                        </div>
                    </div>
                </div>
                <a  href="https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/tax_agent_app/tax_agent.apk">
                    <p style={{ fontSize: 30, textAlign: 'center', }} id='tax_accountant'>
                    税务师引擎
                    {/* <QrCodeIcon onClick={() => handleClickOpen(2)} style={{ marginLeft: 10, cursor: 'pointer' }} /> */}
                    
                        <AndroidIcon style={{marginLeft:'8px'}} /> 
                    </p>
                </a>
                {/* <p style={{fontSize:28,textAlign:'center',margin:'30px 0'}}>税务师引擎</p> */}
                <div>
                    <div style={{ padding: 20 ,paddingBottom:70}}> 
                        <div style={{ width: '70%', textAlign:'center',margin:'0 auto'}}>
                            <LazyLoad height={600} once={true}>
                                <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif/tax_app.gif'} style={{ width: 300 ,maxWidth:'100%'}} alt='' />
                            </LazyLoad>
                        </div>
                        <div style={{textAlign:'center',paddingTop:40}}>
                            <div style={{ fontWeight: 'bold', fontSize: 21 }}>会计实务库搜索</div>
                            <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>毫秒级搜索会计实务相关知识，身旁的便携会计实务专家</div>
                            <div style={{ fontWeight: 'bold', fontSize: 21 }}>价廉物美的服务</div>
                            <div style={{ color: '#536682' ,padding:'30px 0',fontSize: 16}}>只用一块钱就可以在期限内无限次使用，还在等什么，快来试试吧！</div>
                        </div>
                    </div>
                    {/* <div style={{padding: 20 ,backgroundColor:'rgb(61, 17, 152)',margin:'30px 0',paddingBottom:90,marginBottom:0}}>
                        <div style={{color:'#fff',textAlign:'center',fontSize:28,margin:'60px 0'}}>会计实务搜索引擎</div>
                        <div style={{ width: '100%'  }}>
                            <LazyLoad height={450} once={true}>
                                <img src={'https://bohuai-picture-1305959397.cos.ap-shanghai.myqcloud.com/gif%2Faccountant_video_gif.gif'} style={{ width: 750 ,maxWidth:'100%'}} alt='' />
                            </LazyLoad>
                        </div>
                    </div> */}
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#35363A' }}>
                    <div style={{ padding: '20px', width: '100%',textAlign:'center' }}>
                        <div style={{ color: '#fff', fontSize: 12 }}>
                        <a href="https://beian.miit.gov.cn/" style={{ marginRight: 10,cursor: "pointer",}}>京ICP备2021025663号-1</a>
                            <div>博槐（北京）互联网科技有限责任公司</div>
                        </div>
                        <div style={{ color: '#fff', fontSize: 12 }}>
                            <div style={{ marginRight: 10 }}>电话：18910186883</div>
                            <div>邮箱：zhuxihao@huainor.com</div>
                        </div>
                    </div>
                    {/* <div>
                        二维码
                    </div> */}
                </div>
                <SimpleDialog
                    selectedValue={selectedValue}
                    open={open}
                    onClose={handleClose}
                />
            </div>
        </Container>
    );
}

export default Initial;